import { TableColumn } from "@vilocnv/allsetra-core";
import ReportObjectNameCell from "components/common/reports/ReportObjectNameCell";
import {
  calculateTotalBusinessCO2Emissions,
  calculateTotalCommutingCO2Emissions,
  calculateTotalPrivateCO2Emissions
} from "app/data/helpers";
import { round } from "lodash";

export const TOTAL_CO2_REPORT_DATE_RENDERING: TableColumn<any>[] = [
  {
    selector: (row: any) => <div style={{ width: "220px" }}>{row.label}</div>
  },
  {},
  {},
  {
    selector: (row: any) => (
      <div style={{ paddingLeft: "60px" }}>
        {calculateTotalBusinessCO2Emissions(row.data) + " g/km "}
      </div>
    )
  },
  {
    selector: (row: any) => (
      <div style={{ paddingLeft: "60px" }}>
        {calculateTotalPrivateCO2Emissions(row.data) + " g/km "}
      </div>
    )
  },
  {
    selector: (row: any) => (
      <div style={{ paddingLeft: "60px" }}>
        {calculateTotalCommutingCO2Emissions(row.data) + " g/km "}
      </div>
    )
  }
];

export const TOTAL_CO2_REPORT_TABLE_COLUMNS = (
  translator: any,
  isShowKeyCol: boolean
): TableColumn<any>[] => [
  {
    name: translator("tableHeading.businessKm", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: any) => (
      <ReportObjectNameCell name={row?.name} isInactive={row?.isInactive} />
    ),
    wrap: true
  },
  {
    name: translator("tableHeading.privateKm", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.commutingKm", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.businessCO2", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.privateCO2", {
      ns: "tableHeadingsTranslation"
    })
  },
  {
    name: translator("tableHeading.commutingCO2", {
      ns: "tableHeadingsTranslation"
    })
  }
];

export const TOTAL_CO2_REPORT_INNER_TABLE_COLUMNS = (
  translator: any,
  isShowKeyCol?: boolean
) => {
  return [
    {
      cell: (row: any) => {
        return `${row?.businessKilometersDriven ? `${round(row?.businessKilometersDriven, 1).toString().replace(".", ",")} ${"km"}` : "-"}`;
      }
    },
    {
      cell: (row: any) => {
        return `${row?.privateKilometersDriven ? `${round(row?.privateKilometersDriven, 1).toString().replace(".", ",")} ${"km"}` : "-"}`;
      }
    },
    {
      cell: (row: any) => {
        return `${row?.commutingKilometersDriven ? `${round(row?.commutingKilometersDriven, 1).toString().replace(".", ",")} ${"km"}` : "-"}`;
      }
    },
    {
      cell: (row: any) => {
        return `${row?.businessEmissionsDriven ? `${Math.round(row?.businessEmissionsDriven)} g/km` : "-"}`;
      }
    },
    {
      cell: (row: any) => {
        return `${row?.privateEmissionsDriven ? `${Math.round(row?.privateEmissionsDriven)} g/km` : "-"}`;
      }
    },
    {
      cell: (row: any) => {
        return `${row?.commutingEmissionsDriven ? `${Math.round(row?.commutingEmissionsDriven)} g/km` : "-"}`;
      }
    }
  ];
};
